import WonderType from "@/roc/wonders/base/WonderType";
import WonderKind from "@/roc/wonders/base/WonderKind";
import WonderOwner from "@/roc/wonders/base/WonderOwner";
import Effects from '@/roc/effects/Effects';
import PassiveAura from '@/roc/effects/PassiveAura/PassiveAura';
import PassiveAuraType from '@/roc/effects/PassiveAura/PassiveAuraType';
import EffectAmount from '@/roc/effects/EffectAmount';
import PassiveProduction from '@/roc/effects/Production/PassiveProduction';
import ProductionDuration from '@/roc/effects/Production/ProductionDuration';
import ProductionOutput from '@/roc/effects/Production/ProductionOutput';
import ProductionOutputType from '@/roc/effects/Production/ProductionOutputType';
import Synergy from '@/roc/wonders/base/Synergy';
import EraType from '@/roc/era/EraType';

const GreatWall = {
  id: '49',
  name: 'Great Wall',
  era: EraType.earlyRome,
  icon: 'wall',
  gameId: 'GreatWall',
  minLevel: 1,
  maxLevel: 30,
  type: WonderType.GREAT_EMPIRE,
  kind: WonderKind.FORTRESS,
  kindMultiplier: 1,
  owner: WonderOwner.CHINA,
  effects: Effects.create([
    new PassiveAura(
      PassiveAuraType.TOTAL_HIT_POINT_MOD,
      EffectAmount.asPerLevel([
        2.5,
        3.2,
        3.7,
        4.2,
        4.5,  // 5
        4.9,
        5.2,
        5.4,
        5.7,
        5.9,  // 10
        6.2,
        6.4,
        6.6,
        6.8,
        7,  // 15
        7.1,
        7.3,
        7.5,
        7.6,
        7.8,  // 20
        7.9,
        8.1,
        8.2,
        8.4,
        8.5,  // 25
        8.6,
        8.8,
        8.9,
        9,
        9.1   // 30
      ]),
      '%',
    ),
    new PassiveProduction(
      ProductionDuration.asDaily(),
      ProductionOutput.asPerLevel([
        1,
        1,
        1,
        1,
        1, // 5
        1,
        1,
        1,
        1,
        2, // 10
        2,
        2,
        2,
        2,
        2, // 15
        2,
        2,
        2,
        2,
        3, // 20
        3,
        3,
        3,
        3,
        3, // 25
        3,
        3,
        3,
        3,
        4  // 30
      ]).withOutput(ProductionOutputType.RESEARCH_POINTS),
    ),
  ]),
  synergies: [
    {
      effectIndex: 1,
      mod: Synergy.asFlat(1).withKind(WonderKind.FORTRESS),
      effect: null,
    }
  ],
};

export default GreatWall;
